// 项目网上公示记录
<template>
  <div class="projectFormLess">
    <!-- 第一行 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行--项目简介 -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:15px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>项目简介</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.project_content"
        placeholder="请输入单元划分情况"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 第三行--评价组成员 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zy@2x.png" alt />
        <span>评价组成员</span>
      </div>
      <div class="rightInput">
        <el-button @click="handleAddTM" v-if="isSubmit" class="AddUser">添加成员</el-button>
      </div>
    </div>
    <div class="oneRow" style="margin-bottom:35px;padding-left:30px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{background:'#F4F5F6'}"
      >
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="nickName"
          label="姓名"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.nickName}}</span>
            <span v-else>{{scope.row.nickName}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="num" label="资质证书编号" width="180">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.num}}</span>
            <span v-else>{{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="major" label="人员专业">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.major}}</span>
            <span v-else>{{scope.row.major}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="work" label="承担工作">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.work}}</span>
            <span v-else>{{scope.row.work}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <span
              v-if="isSubmit"
              @click="removeUser(scope.$index,scope.row)"
              style="cursor: pointer;color:#128BF1"
            >删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>-->

    <!-- 第四行--技术负责人 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:14px" src="../../assets/image/icon_jishu@2x.png" alt />
        <span>技术负责人</span>
      </div>
      <div class="rightInput">
        <el-input :disabled="!isSubmit" v-model="addFormData.technical_director"></el-input>
      </div>
    </div>-->
    <!-- 第五行--过程控制负责人 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>过程控制负责人</span>
      </div>
      <div class="rightInput">
        <el-input :disabled="!isSubmit" v-model="addFormData.control_director"></el-input>
      </div>
    </div>-->
    <!-- 第六行--报告编制人 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>报告编制人</span>
      </div>
      <div class="rightInput">
        <el-input :disabled="!isSubmit" v-model="addFormData.report_preparer"></el-input>
      </div>
    </div>-->
    <!-- 第七行--报告审核人 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>报告审核人</span>
      </div>
      <div class="rightInput">
        <el-input :disabled="!isSubmit" v-model="addFormData.report_auditor"></el-input>
      </div>
    </div>-->
    <!-- 第八行--参与评价工作的安全评价师 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel" style="width:300px">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>参与评价工作的安全评价师</span>
      </div>
      <div class="rightInput">
        <el-input :disabled="!isSubmit" v-model="addFormData.evaluators"></el-input>
      </div>
    </div>-->
    <!-- 第九行--到现场展开安全评价的人员 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel" style="width:300px">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>到现场展开安全评价的人员</span>
      </div>
      <div class="rightInput">
        <el-input :disabled="!isSubmit" v-model="addFormData.sceneer"></el-input>
      </div>
    </div>-->
    <!-- 第十行--参与安全评价的技术专家 -->
    <!-- <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel" style="width:300px">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>参与安全评价的技术专家</span>
      </div>
      <div class="rightInput">
        <el-input :disabled="!isSubmit" v-model="addFormData.technician"></el-input>
      </div>
    </div>-->

    <!-- 第十一行--现场任务： -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:300px">
        <img style="width:16px" src="../../assets/image/icon_renw@2x.png" alt />
        <span>现场任务：</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.field_tasks"
        placeholder="请输入现场任务"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 十二行--到现场时间and提交报告时间 -->
    <!-- <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
          <span>到现场时间</span>
        </div>
        <div class="rightInput">
          <el-date-picker
            :disabled="!isSubmit"
            value-format="yyyy-MM-dd"
            v-model="addFormData.field_date"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
          <span>提交报告时间</span>
        </div>
        <div class="rightInput">
          <el-date-picker
            :disabled="!isSubmit"
            value-format="yyyy-MM-dd"
            v-model="addFormData.report_date"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
    </div>-->
    <!-- 第十二行--上传附件 -->
    <div class="oneRow">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>

    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->

    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="50%"
      class="addUserDia"
      :before-close="handleCloseAdd"
      @close="handleClosedAdd"
    >
      <div slot="title" class="header-title">
        <span class="title-age">添加成员</span>
      </div>
      <div class="diaContainer">
        <el-form ref="form" :model="AddUserForm" label-width="30%">
          <el-form-item label="姓名">
            <el-input :placeholder="isSubmit ? '请输入姓名' : ''" v-model="AddUserForm.nickName"></el-input>
          </el-form-item>
          <el-form-item label="资质证书编号">
            <el-input :placeholder="isSubmit ? '请输入资质证书编号' : ''" v-model="AddUserForm.num"></el-input>
          </el-form-item>
          <el-form-item label="人员专业">
            <el-input :placeholder="isSubmit ? '请输入人员专业' : ''" v-model="AddUserForm.major"></el-input>
          </el-form-item>
          <el-form-item label="承担工作">
            <el-input :placeholder="isSubmit ? '请输入承担工作' : ''" v-model="AddUserForm.work"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" v-if="diaFormType=='add'" @click="handleAddUser">添 加</el-button>
        <el-button type="primary" v-if="diaFormType=='edit'" @click="editUserForm">修 改</el-button>
      </div>
    </el-dialog>

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :projectId="this.addFormData.project_id"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import UploadFile from '../UploadFile'
export default {
  data() {
    return {
      S_project_name: '',
      approval_remark: '',
      isSubmit: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      // 表格
      editTableIndex: '',
      diaFormType: 'add',
      // 表格
      detailsImgList: [],
      submitImgList: [],
      addFormData: {
        annex: '',
        project_content: '',
        evaluation_team_json: '',
        technical_director: '',
        control_director: '',
        report_preparer: '',
        report_auditor: '',
        evaluators: '',
        sceneer: '',
        technician: '',
        field_tasks: '',
        field_date: '',
        report_date: '',
      },
      AddUserForm: {
        nickName: '',
        num: '',
        major: '',
        work: '',
      },
      dialogVisibleAdd: false,
      infop: '',
      value: '',
      tableData: [],
    }
  },
  methods: {
    // *审批提交
    async handleExamine(val) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      param.append('approval_status', val)
      param.append('remark', this.approval_remark)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/publicity_approval',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      // this.$router.push('/project/index')
      this.getProjectDetails()
    },
    // *编辑提交
    async handleSubmit(val) {
      this.addFormData.evaluation_team_json = JSON.stringify(this.tableData)
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      param.append('is_draft', val)

      // param.append('project_content', this.addFormData.project_content)
      // param.append(
      //   'evaluation_team_json',
      //   this.addFormData.evaluation_team_json
      // )
      // param.append('technical_director', this.addFormData.technical_director)
      // param.append('control_director', this.addFormData.control_director)
      // param.append('report_preparer', this.addFormData.report_preparer)
      // param.append('report_auditor', this.addFormData.report_auditor)
      // param.append('evaluators', this.addFormData.evaluators)
      // param.append('sceneer', this.addFormData.sceneer)
      // param.append('technician', this.addFormData.technician)
      // param.append('field_tasks', this.addFormData.field_tasks)
      // param.append('field_date', this.addFormData.field_date)
      // param.append('report_date', this.addFormData.report_date)

      param.append('annex', JSON.stringify(this.submitImgList))

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/publicity',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      // this.$router.push('/project/index')
      this.getProjectDetails()
    },
    // *获取详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/publicity_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      } else {
        this.addFormData.is_edit = res.datas.info.is_edit
      }
      // 判断禁用
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断表格
      if (this.addFormData.evaluation_team_json) {
        this.tableData = this.addFormData.evaluation_team_json
      }
      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // 判断时间
      if (
        this.addFormData.field_date == 'undefined' ||
        this.addFormData.field_date == 'null'
      ) {
        this.addFormData.field_date = ''
      }
      if (
        this.addFormData.report_date == 'undefined' ||
        this.addFormData.report_date == 'null'
      ) {
        this.addFormData.report_date = ''
      }
      //
      console.log('整改通知单-详情', this.addFormData)
    },
    // 文件上传
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    // 表格相关
    removeUser(index, row) {
      this.tableData.splice(index, 1)
      console.log(this.tableData)
    },
    handleAddTM() {
      this.diaFormType = 'add'
      this.dialogVisibleAdd = true
    },
    tableClick(row, column, event) {
      this.diaFormType = 'edit'
      this.editTableIndex = this.tableData.findIndex(
        (item) => item.id == row.id
      )
      this.AddUserForm = row
      this.dialogVisibleAdd = true
    },
    editUserForm() {
      this.tableData[this.editTableIndex] = this.AddUserForm
      this.dialogVisibleAdd = false
    },
    handleAddUser() {
      this.tableData.push({
        id: new Date().getTime(),
        nickName: this.AddUserForm.nickName,
        num: this.AddUserForm.num,
        major: this.AddUserForm.major,
        work: this.AddUserForm.work,
      })
      this.dialogVisibleAdd = false
    },
    // 表格相关
    async handleBefore(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      this.editUserForm.avatar = res.datas.img_url
      console.log('头像', this.editUserForm.avatar)
    },
    handleCloseAdd() {
      this.dialogVisibleAdd = false
    },
    handleClosedAdd() {
      this.AddUserForm = {
        nickName: '',
        num: '',
        major: '',
        work: '',
      }
      this.diaFormType = 'add'
      this.editTableIndex = ''
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>